<template>
  <div v-if="config_ativar_filtro_produtos_inativos_tela_compras">
    <DivisorComLegenda v-if="!ocultar_divisor" legenda="Flags produtos inativos" class="mb-4 mt-6" />

    <v-switch
      v-model="VALOR"
      hide-details
      :color="color"
    >
      <template #label>
        <span class="pl-2">Exibir produtos inativos com movimentação nos últimos 90 dias ou com pedidos pendentes</span>
      </template>
    </v-switch>
  </div>
</template>

<script>
import DivisorComLegenda from "@/components/utils/DivisorComLegenda.vue";

export default {
  name: "FiltroExibirProdutosInativos",
  components: {DivisorComLegenda},
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: Boolean,
    ocultar_divisor: Boolean,
    color: {
      type: String,
      default: '#a71830'
    }
  },
  emits: ['update:modelValue'],
  data: () => ({
    config_ativar_filtro_produtos_inativos_tela_compras: localStorage.getItem('config_ativar_filtro_produtos_inativos_tela_compras') === 'S',
  }),
  computed: {
    VALOR: {
      get: function () {
        return this.modelValue;
      },
      set: function (valor) {
        this.$emit('update:modelValue', valor);
      }
    }
  }
}
</script>
